import { defaultPageConfig } from '@app/recoil';

import { atom } from 'recoil';
import type { PageConfig } from '@app/config';

const pageConfigRecoilState = atom<PageConfig | null>({
  key: 'global.pageConfig',
  default: defaultPageConfig,
});

export default pageConfigRecoilState;
